import React from 'react';
import 'react-h5-audio-player/lib/styles.css';
import AudioPlayer from 'react-h5-audio-player';
import { Card, Image } from 'react-bootstrap';
import './AudioPlayerComponent.css'; 
import profilePhoto from '../assets/yourPhoto.png';

const AudioPlayerComponent = ({ src, title, artist }) => {
 

  return (
    <Card className="audio-player-container">
      <Card.Body className="d-flex">
        <div className="audio-info">
          <Card.Title className="text-center">{title}</Card.Title>
          <Card.Subtitle className="mb-2 text-muted text-center">{artist}</Card.Subtitle>
          <AudioPlayer
            autoPlay={false}
            src={src}
            onPlay={e => console.log("onPlay")}
            style={{ border: 'none', margin: '0' }}
            // other props here
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default AudioPlayerComponent;
